import { render, staticRenderFns } from "./HospitalAdd.vue?vue&type=template&id=d8342dfa&scoped=true"
import script from "./HospitalAdd.vue?vue&type=script&lang=js"
export * from "./HospitalAdd.vue?vue&type=script&lang=js"
import style0 from "./HospitalAdd.vue?vue&type=style&index=0&id=d8342dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8342dfa",
  null
  
)

export default component.exports